import React from 'react';
import { Row, Col } from 'antd';
import moment from 'moment';
import { DivItems } from '../../../../components/EditForm/styles';
import { Text } from '../../../../components/Text';

export default function InfoProprietarioCavaloLeitura({ dadosProp }) {
  const colStyle = {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
  };

  return dadosProp?.proprietarios?.map((item, index) => {
    const tituloSecao = item?.detalheTipoCadastro;

    return item?.proprietario?.pessoaFisicaCadastro?.cpf ? (
      <Col key={index}>
        <Row
          justify="space-between"
          style={{
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            marginTop: 32,
          }}
        >
          <Col span={24} style={colStyle}>
            <Text
              title="Nome"
              value={item?.pessoaFisicaCadastro?.nome || '-'}
            />
            <Text
              title="CPF"
              value={
                item?.pessoaFisicaCadastro?.cpf.replace(
                  /(\d{3})(\d{3})(\d{3})(\d{2})/g,
                  '$1.$2.$3-$4'
                ) || '-'
              }
            />
            <Text
              title="RNTRC"
              value={item?.proprietarioCadastro?.rntrc || '-'}
            />
          </Col>
          <Col span={24} style={colStyle}>
            <Text
              title="VALIDADE RNTRC"
              value={
                item?.motoristaCadastro?.vencimentoRNTRC
                  ? moment(item?.motoristaCadastro?.vencimentoRNTRC).format(
                      'DD/MM/YYYY'
                    )
                  : '-'
              }
            />
            <Text title="Contato" value={item?.telefone || '-'} />
            <Text
              title="Nome da Mãe"
              value={item?.pessoaFisicaCadastro?.nomeMae || '-'}
            />
          </Col>
          <Col span={24} style={colStyle}>
            <Text
              title="Nº id. do trabalhador (NIT)"
              value={item.pessoaFisicaCadastro?.numeroPIS || '-'}
            />
            <Text title="Endereço" value={item.endereco || '-'} />
          </Col>
        </Row>
      </Col>
    ) : (
      <Col key={index}>
        <Row
          justify="space-between"
          style={{
            display: 'flex',
            width: '100%',
            flexDirection: 'column',
            marginTop: 32,
          }}
        >
          <Col span={24} style={colStyle}>
            <Text
              title="Nome Fantasia"
              value={item?.pessoaJuridicaCadastro?.nomeFantasia || '-'}
            />
            <Text
              title="Razão Social"
              value={item?.pessoaJuridicaCadastro?.razaoSocial || '-'}
            />
          </Col>
        </Row>
      </Col>
    );
  });
}
